/**
 * Calculates the normalized index of a carousel item relative to the active slide
 * Handles looping carousel behavior where items wrap around
 * @param itemIndex - The absolute index of the item
 * @param activeIndex - The index of the currently active slide
 * @param totalItems - Total number of items in the carousel
 * @returns The normalized index (0-based position relative to active slide)
 */
export function getNormalizedCarouselIndex(itemIndex: number, activeIndex: number, totalItems: number): number {
  return (itemIndex - activeIndex + totalItems) % totalItems;
}

/**
 * Determines if a carousel item should have borders based on its position and screen layout
 * @param normalizedIndex - The normalized index from getNormalizedCarouselIndex
 * @returns Object with border conditions for different layouts
 */
export function getCarouselItemBorderConditions(normalizedIndex: number) {
  return {
    isMiddleCard: normalizedIndex === 1, // Middle card in 3-card desktop layout
    isFirstCardOnTablet: normalizedIndex === 0, // First card in 2-card tablet layout
  };
}
